import classNames from 'classnames'
import {
  GetAnalyticsDetailFilter,
  GetAnalyticsDetailFilterDetails,
  POLICY_TYPE,
  RESOURCE_TYPE,
  SearchSuggestion,
  DetailTableRenderDataParams,
  DetailTableRenderColumnParams,
} from 'interfaces'
import {RefObject} from 'react'
import {transformDateToLocal} from 'utils'
import DetailColumnElement from './components/DetailColumnElement'

const noTransform = (value: string) => value
const transform = noTransform

export const MAX_ROW_ON_TABLE = 15
export const policyTypeFiltersDisplayValue = [
  'Policy',
  'Malware',
  'Cloud App Control',
]

export const policyTypeFilterValues = [...Object.values(POLICY_TYPE)]

export const parseResourceTypeSearchSuggestionFilter = (
  suggestion: SearchSuggestion,
): GetAnalyticsDetailFilter => {
  const {resourceType} = suggestion || {}
  const filter = {
    resourceType: [resourceType],
    filterDetails: {} as GetAnalyticsDetailFilterDetails,
  }
  if (resourceType === RESOURCE_TYPE.Location) {
    filter.filterDetails.city = suggestion?.city
    filter.filterDetails.country = suggestion?.country
  } else if (resourceType === RESOURCE_TYPE.Groups) {
    filter.filterDetails.groupEmail = suggestion.emailId
  } else {
    // no suggestion, fallback to display value
    filter.filterDetails.userEmail =
      suggestion.emailId || suggestion.displayValue
  }

  return filter
}

export const detailTableColumns = (
  typeFilterRef?: RefObject<HTMLButtonElement>,
  setShowTypeFilters?: React.Dispatch<React.SetStateAction<boolean>>,
  showTypeFilters?: boolean,
) => {
  return [
    {name: 'Domain', dataKey: 'domain', widthPercentage: 15, transform},
    {name: 'Url Path', dataKey: 'urlPath', widthPercentage: 18, transform},
    {
      name: 'Location',
      dataKey: 'location',
      widthPercentage: 10,
      transform,
      renderData: ({
        classes,
        value,
        dispatchSetAnalyticsDetailFilters,
      }: DetailTableRenderDataParams) => {
        const handleOnUserClick = (): void => {
          const [city = '', country = ''] = (value || '').split(',')
          const filters = {
            resourceType: [RESOURCE_TYPE.Location],
            filterDetails: {
              city: city.trim(),
              country: country.trim(),
            },
          }
          dispatchSetAnalyticsDetailFilters(filters)
        }
        return (
          <span
            className={classNames(classes, 'hover:underline cursor-pointer')}
            onClick={handleOnUserClick}
          >
            {value}
          </span>
        )
      },
    },
    {
      name: 'Process Name',
      dataKey: 'processName',
      widthPercentage: 14,
      transform,
    },
    {name: 'Category', dataKey: 'category', widthPercentage: 8, transform},
    {
      name: 'User',
      dataKey: 'user',
      widthPercentage: 12,
      transform,
      renderData: ({
        classes,
        value,
        dispatchSetAnalyticsDetailFilters,
      }: DetailTableRenderDataParams) => {
        const handleOnUserClick = (): void => {
          const filters = {
            resourceType: [RESOURCE_TYPE.Users],
            filterDetails: {
              userEmail: value,
            },
          }
          dispatchSetAnalyticsDetailFilters(filters)
        }
        return (
          <span
            className={classNames(classes, 'hover:underline cursor-pointer')}
            onClick={handleOnUserClick}
          >
            {value}
          </span>
        )
      },
    },
    {
      name: 'Type',
      dataKey: 'type',
      classes: 'capitalize',
      widthPercentage: 6,
      transform: (value: string) => {
        if (value === POLICY_TYPE.CAC) {
          return value?.toUpperCase()
        } else if (
          value
            ?.toLowerCase()
            ?.includes(policyTypeFiltersDisplayValue[0]?.toLowerCase())
        ) {
          return policyTypeFiltersDisplayValue[0]
        } else {
          return value
        }
      },
      renderColumn: ({name}: DetailTableRenderColumnParams) => {
        return (
          <DetailColumnElement
            column={name}
            typeFilterRef={typeFilterRef}
            showTypeFilters={showTypeFilters}
            setShowTypeFilters={setShowTypeFilters}
          />
        )
      },
    },
    {
      name: 'Verdict',
      dataKey: 'verdict',
      classes: 'capitalize',
      widthPercentage: 5,
      transform,
    },
    {
      name: 'Time',
      dataKey: 'time',
      classes: 'text-gray-600',
      widthPercentage: 12,
      transform: transformDateToLocal,
      renderColumn: ({name}: DetailTableRenderColumnParams) => {
        return (
          <DetailColumnElement
            column={name}
            typeFilterRef={typeFilterRef}
            showTypeFilters={showTypeFilters}
            setShowTypeFilters={setShowTypeFilters}
          />
        )
      },
    },
  ]
}
